import React, { useCallback, useEffect, useState } from 'react'
import { IProductAdmin, IProductImages } from '../../models/admin/products'
import { useParams } from 'react-router-dom'
import api from '../../api/api'
import { environment } from '../../environments/environment'
import { Skeleton, Stack } from '@mui/material'
import { ProductCard } from '../../components/ProductCard'



const ProductSearchResult = () => {
  const { searchQuery } = useParams<{ searchQuery: string }>()
  const [products, setProducts] = useState<IProductAdmin[] | null>(null)
  const [productImages, setProductImages] = useState<IProductImages[] | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)
  const [ordersData, setOrdersData] = useState<{ [key: string]: number }>({})

  const fetchSearchResult = useCallback(async (query: string) => {
    setIsLoading(true)
    setError(null)

    try {
      const response = await api.get(`${environment.baseUrl}/product/search?q=${query}`)
      
      if (response.data.success) {
        const productImages = response.data.data.product_images

        const extractedImages = Object.values(productImages)
          .flat()
          .filter((img: any) => img.media_url)
          .map((img: any) => ({
            product_uuid: img.product_uuid,
            media_url: img.media_url,
          }))

        setProductImages(extractedImages)
        setProducts(response.data.data?.products || [])
      } else {
        setError('Failed to fetch search results')
      }
    } catch (error) {
      console.error(error)
      setError('An error occurred while fetching search results')
    }
    finally {
      setIsLoading(false)
    }
  }
  , [])

  useEffect(() => {
    if(searchQuery){
      fetchSearchResult(searchQuery)
    }
  }, [searchQuery, fetchSearchResult])

   if (!searchQuery) {
    return <div>No search query provided</div>;
  }
  
  return (
    <main className="web_padding_y web_padding_x">
      <h2 className="web_heading text-left md:text-center ">
        SEARCH RESULTS FOR &ldquo;{searchQuery}&rdquo;
      </h2>
      <div className="flex cont mt-5 md:mt-10">
        {isLoading && (
          <Stack spacing={1}>
            <Stack spacing={1} direction="row">
              {[...Array(3)].map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rounded"
                  width={400}
                  height={200}
                />
              ))}
            </Stack>
            <Stack spacing={1} direction="row">
              {[...Array(3)].map((_, index) => (
                <Skeleton
                  key={index + 3}
                  variant="rounded"
                  width={400}
                  height={200}
                />
              ))}
            </Stack>
          </Stack>
        )}

        {error && <div className="text-red-500">{error}</div>}

        {!isLoading && !error && products && (
          <>
            {products.length > 0 ? (
              <div className="grid gap-6 sm:[grid-template-columns:repeat(auto-fill,minmax(300px,_1fr))] lg:grid-cols-3">
                {products.map((product: IProductAdmin) => {
                  const productImageUrl = productImages?.find((img) => img.product_uuid === product.uuid)?.media_url || ''
                  return (
                    <ProductCard
                      key={product.uuid}
                      product={product}
                      productImage={productImageUrl}
                    />
                  )
                }
                )}
              </div>
            ) : (
                <div className="border border-dashed text-center border-gray-400 mt-4 mx-auto max-w-[450px] rounded-lg px-10 py-20">
                No product found
              </div>
            )}
          </>
        )}

      </div>
      </main>
  )
}

export default ProductSearchResult